import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { withRouter } from "react-router-dom";

import Chemistry from '../../../../images/chemistry_icon.png';
import Physics from '../../../../images/physics_icon.png';
import Maths from '../../../../images/maths_icon.png';
import Botany from '../../../../images/botany_icon.png';
import Arrow from "../../../../images/eamcet_arrow.png";
import "./_cbse_foundation.scss";

class CBSEFoundationSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            getSubjectsArr: [
                { id: 1, subject: "Mathematics", active: "active" },
                { id: 2, subject: "Physics", active: "" },
                { id: 3, subject: "Chemistry", active: "" },
                { id: 4, subject: "Biology", active: "" }
            ],

            selectedSubjectVal: 1,

            // Initial chapters based on subject: 1
            ChaptersArray: props.chapterData
                ? props.chapterData.filter(item => item.subject_id == 1)
                : []
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.classId !== this.props.classId) {

            const resetSubjects = this.state.getSubjectsArr.map((sub, index) => ({
                ...sub,
                active: index === 0 ? "active" : ""
            }));

            this.setState({
                selectedSubjectVal: 1,
                getSubjectsArr: resetSubjects,
                ChaptersArray: this.props.chapterData.filter(item => item.subject_id == 1)
            });
        }
    }

    getSubjectImage(id) {
        switch (id) {
            case 1: return Maths;
            case 2: return Physics;
            case 3: return Chemistry;
            case 4: return Botany;
            default: return "";
        }
    }

    handleSelect = (subid) => {
        const updatedSubjects = this.state.getSubjectsArr.map(sub => ({
            ...sub,
            active: sub.id === subid ? "active" : ""
        }));

        this.setState({
            getSubjectsArr: updatedSubjects,
            selectedSubjectVal: subid,

            // Filter chapters based on selected subject
            ChaptersArray: this.props.chapterData.filter(item => item.subject_id == subid)
        });
    };

    navigateToChapter(item, index) {
        const { classId } = this.props;
        const subjectId = this.state.selectedSubjectVal;

        const subjectName = this.state.getSubjectsArr.find(s => s.id === subjectId)?.subject;
        const chapterName = item.chapter_name;

        this.props.history.push({
            pathname: `/cbse/class-${classId}/subject-${subjectId}/chapter-${index + 1}/short-notes`,
            state: {
                subjectName,
                chapterName
            }
        });
    }

    render() {
        const { ChaptersArray } = this.state;

        return (
            <Container className="premium-ui-container mt-4">

                {/* SUBJECT CARDS */}
                <Row>
                    {this.state.getSubjectsArr.map(sub => (
                        <Col sm={6} lg={3} key={sub.id}>
                            <div
                                className={`subject-card ${sub.active}`}
                                onClick={() => this.handleSelect(sub.id)}
                            >
                                <img
                                    src={this.getSubjectImage(sub.id)}
                                    className="subject-icon"
                                    alt={sub.subject}
                                />
                                <h5 className="subject-title">{sub.subject}</h5>
                            </div>
                        </Col>
                    ))}
                </Row>

                {/* CHAPTER CARDS */}
                <Row className="mt-4">
                    {ChaptersArray.length === 0 ? (
                        <Col sm={12}>
                            <div className="no-chapters-box">
                                <h6 className="text-center text-muted">No chapters available</h6>
                            </div>
                        </Col>
                    ) : (
                        ChaptersArray.map((item, index) => (
                            <Col sm={12} lg={6} key={index}>
                                <div
                                    className="chapter-premium-card"
                                    onClick={() => this.navigateToChapter(item, index)}
                                >
                                    <div className="chapter-content">
                                        <h6 className="chapter-name">
                                            {index + 1}. {item.chapter_name}
                                        </h6>
                                        <img src={Arrow} className="chapter-arrow" alt="arrow" />
                                    </div>
                                </div>
                            </Col>
                        ))
                    )}
                </Row>

            </Container>
        );
    }
}

export default withRouter(CBSEFoundationSection);
